import type { FaireProductEntity } from "../../entity_types/product";

export const p_yeu344evt3: FaireProductEntity = {
  token: "p_yeu344evt3",
  type: "product",
  name: "Aloha Journals",
  brandName: "Kailua Beads",
  imageUrl:
    "https://cdn.faire.com/fastly/e43ae095357bfc39649681e4cb33de62f9f13cc0b64904314df40593ade34063.png",
  priceDollars: 10,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a8b12c6d23dbcf01572645d00bb70172677203e82d1e248f91460720c94f0c4f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
